module.exports = __webpack_public_path__ + "static/media/homeVideo.e9828cf6.mp4";